export const discountTypes = {
  percentage: 'Percentage',
  fixed: 'Fixed',
  none: 'None',
}

export const discountVariations = {
  upto: 'Upto',
  flat: 'Flat',
}

// Aspect ratio buffer to consider a logo as rectangular
export const squareAspectRatioBuffer = 1.3